import { AppConfig } from "../../app/app.config";

export class SignUpData {
  user: {
    gender: number;
    first_name: string;
    last_name: string;
    email: string;
    birthday: Date;
    facebook_friend_count?: number;
  };
  property: {
    nickname: string;
    employer?: string;
    education_type?: string;
    school_name?: string;
  };
  facebook: {
    facebook_user_id: string;
    access_token: string;
    expires_in: number;
  };
  image: { image_url: string };
  invite_token: string;
  web_track_token: string;
  code: string;
  token: string;
  for_cast?: boolean;

  constructor(fields: any) {
    this.init();
    for (const f in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, f)) {
        this[f] = fields[f];
      }
    }
  }

  init() {
    this.user = {
      gender: 1,
      first_name: "",
      last_name: "",
      email: "",
      birthday: null,
    };
    this.property = { nickname: "" };
    this.image = { image_url: "assets/img/default-user-image/male.png" };
    this.invite_token = "";
    this.web_track_token = "";
  }

  setSignupData(newSignupData: SignUpData) {
    if (!newSignupData) {
      return;
    }
    this.user = newSignupData["user"];
    this.property = newSignupData["property"];
    this.image = newSignupData["image"];
    if (newSignupData["invite_token"]) {
      this.invite_token = newSignupData["invite_token"];
    }
    if (newSignupData["web_track_token"]) {
      this.web_track_token = newSignupData["web_track_token"];
    }
  }

  setSignupDataForFacebookProfile(facebookProfile: FacebookProfile) {
    if (facebookProfile.gender === "female") {
      this.user.gender = 2;
    } else {
      this.user.gender = 1;
    }

    this.user.first_name = facebookProfile.first_name;
    this.user.last_name = facebookProfile.last_name;
    if (facebookProfile.email) {
      this.user.email =
        facebookProfile.email + AppConfig.META_DATA.facebookLoginPrefix;
    } else {
      this.user.email = facebookProfile.email;
    }

    if (facebookProfile.birthday) {
      this.user.birthday = new Date(facebookProfile.birthday);
    }
    if (
      facebookProfile.friends &&
      facebookProfile.friends.summary &&
      facebookProfile.friends.summary.total_count
    ) {
      this.user.facebook_friend_count =
        facebookProfile.friends.summary.total_count;
    }
    if (facebookProfile.work && facebookProfile.work.length > 0) {
      if (facebookProfile.work[0]["employer"]) {
        this.property.employer = facebookProfile.work[0]["employer"]["name"];
      }
    }
    if (facebookProfile.education && facebookProfile.education.length > 0) {
      const lastSchool =
        facebookProfile.education[facebookProfile.education.length - 1];
      if (lastSchool["type"] && lastSchool["type"] === "High School") {
        // 高校卒
        this.property.education_type = "high_school";
      } else if (lastSchool["type"] && lastSchool["type"] === "College") {
        // 大学卒
        this.property.education_type = "college";
      }
      if (lastSchool["school"]) {
        this.property.school_name = lastSchool["school"]["name"];
      }
    }

    // nicknameの初期値は名前
    this.property.nickname = facebookProfile.first_name;

    // Facebook Graph API v8対応
    let accessToken =
      "&access_token=1177390178977826|ebf309476fef98c6632faa2fdc0efe31";
    if (AppConfig.META_DATA.appID === "member") {
      accessToken =
        "&access_token=2425549100848504|8fe79c380905c5da1efffec00abcde32";
    }
    this.image.image_url =
      "https://graph.facebook.com/" +
      facebookProfile.userId +
      "/picture?width=1125&height=1125" +
      accessToken;
  }
}

export const enum LINELoginType {
  NormalLogin = "cast",
  CastApplied = "cast_applied",
}
export class SignUpDataOAuth {
  code: string;
  state: string;
  invite_token: string;
  web_track_token: string;
  app_id: string;
  os_type: string;
  line_location_id: number; // キャスト応募用のLINEロケーション情報
  line_login_type: string | LINELoginType | null;
  phone: string;
  sign_up_data_phone_auth: SignUpDataPhoneAuth; // LINEログインからの電話番号認証パターン
  location_id: number;
  access_token: string; // Cordova LINE認証用のアクセストークン

  constructor(fields: any) {
    for (const f in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, f)) {
        this[f] = fields[f];
      }
    }
  }

  setSignUpDataPhoneAuth(signupData: SignUpDataPhoneAuth) {
    this.sign_up_data_phone_auth = signupData;
  }

  setLocationId(locationId: number) {
    this.location_id = locationId;
  }
}

export class SignUpDataPhoneAuth {
  phone: string; // 電話番号認証のSMS受信用番号
  code: string; // 認証用コード
  token: string; // ワンタイムトークン
  mail?: string; // メールアドレスログイン用

  constructor(fields: any) {
    for (const f in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, f)) {
        this[f] = fields[f];
      }
    }
  }
}

export class FacebookProfile {
  userId: string;
  gender: string;
  first_name: string;
  last_name: string;
  email: string;
  birthday: string;
  friends: {
    summary: { total_count: number };
  };
  facebook_friend_count: number;
  work: [{ employer: { name: string } }];
  education: [{ type: string }];

  constructor(fields: any) {
    for (const f in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, f)) {
        this[f] = fields[f];
      }
    }
  }

  setUserId(userId: string): void {
    this.userId = userId;
  }
}

export type AppleSignInDataJSON = {
  identity_token: string;
  nonce: string;
  family_name: string;
  given_name: string;
  apple_id: string;
  for_cast: boolean;
};
